/**
 * 将所有的cac整改配置收拢到该文件，将代码里的写死域名之类的也收拢到该文件，在此集中disable相关eslint
 */
/* eslint-disable @tencent/tdoc-standalone/no-use-uri-like-literal,@tencent/tdoc-standalone/no-use-location-host */
import DocsConfig from '@tencent/docs-config';
var appConfigInstance = DocsConfig.getInstance();
var npmConfig = appConfigInstance.getConfig('npm["@tencent/docs_offline"]');
export var TOC_ORIGIN = (npmConfig === null || npmConfig === void 0 ? void 0 : npmConfig.TOC_ORIGIN) || 'https://docs.qq.com';
//# sourceMappingURL=index.js.map